// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('#theme-header').outerHeight();


// function to animate warranties section on balance page
function checkElementLocation() {
var $window = $(window);
var bottom_of_window = $window.scrollTop() + $window.height();

var $that = $('.balance-warranties');
var bottom_of_object = $that.position().top;

//if element is in viewport, add the animate class
  if (bottom_of_window > bottom_of_object) {
    $('.bal-icon.icon_25').addClass('fade-in');
    setTimeout(function(){ $('.bal-icon.icon_30').addClass('fade-in'); }, 500);
    setTimeout(function(){ $('.bal-icon.icon_40').addClass('fade-in'); }, 800);
    setTimeout(function(){ $('.bal-icon.icon_50').addClass('fade-in'); }, 1000);
  }
}
// if in viewport, show the animation
//checkElementLocation();

// function to animate first balance three section on balance page
function checkBalance1() {
  var $window_bal1 = $(window);
  var bottom_of_window_bal1 = $window_bal1.scrollTop() + $window_bal1.height();

  var $that_bal1 = $('#shopify-section-template--16308378042557__58fa15ae-ddbb-4aaa-8f28-2f98730a76a0.balance-three');
  if($that_bal1.length) {
    var bottom_of_object_bal1 = $that_bal1.position().top;
    if (bottom_of_window_bal1 > bottom_of_object_bal1) {
      $("#shopify-section-template--16308378042557__58fa15ae-ddbb-4aaa-8f28-2f98730a76a0 .balance-block .balance-list").addClass('fadeInDown');
    }
  }
}
//checkBalance1();

// function to animate second balance three section on balance page
function checkBalance2() {
  var $window_bal2 = $(window);
  var bottom_of_window_bal2 = $window_bal2.scrollTop() + $window_bal2.height();

  var $that_bal2 = $('#shopify-section-template--16308378042557__2d3485d1-c329-4702-91cf-47a8e1f854ca.balance-three');
  if($that_bal2.length) {
    var bottom_of_object_bal2 = $that_bal2.position().top;
    if (bottom_of_window_bal2 > bottom_of_object_bal2 + 50) {
      $("#shopify-section-template--16308378042557__2d3485d1-c329-4702-91cf-47a8e1f854ca .balance-block .balance-list").addClass('fadeInDown');
    }
  }
}
//checkBalance2();

// function to animate third balance three section on balance page
function checkBalance3() {
  var $window_bal3 = $(window);
  var bottom_of_window_bal3 = $window_bal3.scrollTop() + $window_bal3.height();

  var $that_bal3 = $('#shopify-section-template--16308378042557__169861ff-a062-4368-98d6-ba24152388ad.balance-three');
  if($that_bal3.length) {
    var bottom_of_object_bal3 = $that_bal3.position().top;
    if (bottom_of_window_bal3 > bottom_of_object_bal3 + 50) {
      $("#shopify-section-template--16308378042557__169861ff-a062-4368-98d6-ba24152388ad .balance-block .balance-list").addClass('fadeInDown');
    }
  }
}
//checkBalance3();

// function to animate the last deck you will ever build section on balance page
function checkTheLastDeck() {
  var $window_deck = $(window);
  var bottom_of_window_deck = $window_deck.scrollTop() + $window_deck.height();

  var $that_deck = $('#shopify-section-template--16308378042557__e2b1852d-1756-49e9-9cdd-a7527ec55c96');
  if($that_deck.length) {
    var bottom_of_object_deck = $that_deck.position().top;
    if (bottom_of_window_deck > bottom_of_object_deck + 50) {
      $("#shopify-section-template--16308378042557__e2b1852d-1756-49e9-9cdd-a7527ec55c96 .text-and-image-grid-list").addClass('fadeInDown');
    }
  }
}
//checkTheLastDeck();

// function to animate the yellowstone section on balance page
function checkYStone() {
  var $window_stone = $(window);
  var bottom_of_window_stone = $window_stone.scrollTop() + $window_stone.height();

  var $that_stone = $('#shopify-section-template--16308378042557__c42d6739-77e2-469e-8dfa-355ff2a5dca7');
  if($that_stone.length) {
    var bottom_of_object_stone = $that_stone.position().top;
    if (bottom_of_window_stone > bottom_of_object_stone + 50) {
      $("#shopify-section-template--16308378042557__c42d6739-77e2-469e-8dfa-355ff2a5dca7 .text-and-image-grid-list").addClass('fadeInDown');
    }
  }
  
}
//checkYStone();

if(isBalancePage){
    checkTheLastDeck();
    checkYStone();
    checkBalance1();
    checkBalance2();
    checkBalance3();
    checkElementLocation();
}

$(window).scroll(function(event){
    didScroll = true;
  
    if(isBalancePage){
        checkTheLastDeck();
        checkYStone();
        checkBalance1();
        checkBalance2();
        checkBalance3();
        checkElementLocation();
    }
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('#theme-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('#theme-header').removeClass('nav-up').addClass('nav-down');
        }
    }
    
    lastScrollTop = st;
}

$(document).ready(function(){
    $(".swiper-wrapper").css("transition-duration","300ms");
    
    var width1280 = window.matchMedia("(min-width: 1280px)");
    var width991 = window.matchMedia("(min-width: 991px) and (max-width: 1270px)");
    var width768 = window.matchMedia("(min-width: 768px) and (max-width: 990px)");
    var width414 = window.matchMedia("(min-width: 391px) and (max-width: 767px)");
    var width375 = window.matchMedia("(max-width: 390px)");

    if (width1280.matches){
      swImgHeight = "515px";
    }
    if (width991.matches){
      swImgHeight = "403px";
    }
    if (width768.matches){
      swImgHeight = "736px";
    }
    if (width414.matches){
      swImgHeight = "377px";
    }
    if (width375.matches){
      swImgHeight = "338px";
    }

    //console.log(swImgHeight);
    $(".swiper-wrapper").css("height",swImgHeight);

    // code to open external navigation links in new tab
    $('.header__submenu a').each(function() {
       var a = new RegExp('/' + window.location.host + '/');
       if(!a.test(this.href)) {
           $(this).click(function(event) {
               event.preventDefault();
               event.stopPropagation();
               window.open(this.href, '_blank');
           });
       }
    });

    // add css for mobile accordian
    var mobScreen = window.matchMedia("(max-width: 767px)");
    if (mobScreen.matches){
        $('#shopify-section-template--15163568849085__faq').closest('.grid__item-col-2').css("width","100%");
    }

    // Scroll to event for balance page hero button
    $('.video-banner-logo .button').click(function(event) {

        // The id of the section we want to go to.
        var id = "#shopify-section-template--16308378042557__e2b1852d-1756-49e9-9cdd-a7527ec55c96";

        // An offset to push the content down from the top.
        var offset = 0;

        // Our scroll target : the top position of the
        // section that has the id referenced by our href.
        var target = $(id).offset().top - offset;

        // The magic...smooth scrollin' goodness.
        $('html, body').animate({scrollTop:target}, 1000);

        //prevent the page from jumping down to our section.
        event.preventDefault();
    });

});

$( window ).resize(function() {
    var mobScreen2 = window.matchMedia("(max-width: 767px)");
    if (mobScreen2.matches){
        $('#shopify-section-template--15163568849085__faq').closest('.grid__item-col-2').css("width","100%");
    }
    else
    {
      $('#shopify-section-template--15163568849085__faq').closest('.grid__item-col-2').css("width","calc(66.67% - 1rem * 2 / 3)");
    }
});

let v100 = $('#shopify-section-template--15811711402173__1635172019014c1f69');
let v100_st = false;
let v100_chk = false;

let v15k = $('#shopify-section-template--15811711402173__16351718095cee844f');
let v15k_st = false;
let v15k_chk = false;

let v5300 = $('#shopify-section-template--15811711402173__1635172153f2c5f7da');
let v5300_st = false;
let v5300_chk = false;

let v98 = $('#shopify-section-template--15811711402173__16351723259261e814');
let v98_st = false;
let v98_chk = false;

$(window).on('scroll', function() {

  // Increment counter code for 100 millions pounds
  if (document.getElementById("shopify-section-template--15811711402173__1635172019014c1f69") && ($(window).scrollTop() >= v100.offset().top - v100.outerHeight()) && v100_st == false && v100_chk == false) {
    v100_chk = true
     const v100_counters = document.querySelectorAll('#Banner-template--15811711402173__1635172019014c1f69 .banner__heading') 
     v100_counters.forEach(v100_counter => {  
       v100_counter.innerText = '1'  
       const v100_updateCounter = () => {  
         const v100_target = +100  
         const v100_c = +v100_counter.innerText  
         const v100_increment = 1  
         if(v100_c < v100_target) {  
           v100_counter.innerText = `${Math.ceil(v100_c + v100_increment)}`  
           setTimeout(v100_updateCounter, 15)  
         } else {  
           v100_counter.innerText = v100_target 
           v100_st = true
         }  
       }  
       v100_updateCounter()  
     })
  }

  // Increment counter code for 15000 football fields
  if (document.getElementById("shopify-section-template--15811711402173__16351718095cee844f") && ($(window).scrollTop() >= v15k.offset().top - v15k.outerHeight()) && v15k_st == false && v15k_chk == false) {
     v15k_chk = true
     const v15k_counters = document.querySelectorAll('#Banner-template--15811711402173__16351718095cee844f .banner__heading') 
     v15k_counters.forEach(v15k_counter => {  
       v15k_counter.innerText = '1'  
       const v15k_updateCounter = () => {  
         const v15k_target = +15  
         const v15k_c = +v15k_counter.innerText  
         const v15k_increment = 1  
         if(v15k_c < v15k_target) {  
           v15k_counter.innerText = `${Math.ceil(v15k_c + v15k_increment)}`  
           setTimeout(v15k_updateCounter, 60)  
         } else {  
           v15k_counter.innerText = v15k_target 
           v15k_st = true
         }  
       }  
       v15k_updateCounter()  
     })
  }

  // Increment counter code for 5300 pools water
  if (document.getElementById("shopify-section-template--15811711402173__1635172153f2c5f7da") && ($(window).scrollTop() >= v5300.offset().top - v5300.outerHeight()) && v5300_st == false && v5300_chk == false) {
     v5300_chk = true
     const v5300_counters = document.querySelectorAll('#Banner-template--15811711402173__1635172153f2c5f7da .banner__heading') 
     v5300_counters.forEach(v5300_counter => {  
       v5300_counter.innerText = '1'  
       const v5300_updateCounter = () => {  
         const v5300_target = +53  
         const v5300_c = +v5300_counter.innerText  
         const v5300_increment = 1  
         if(v5300_c < v5300_target) {  
           v5300_counter.innerText = `${Math.ceil(v5300_c + v5300_increment)}`  
           setTimeout(v5300_updateCounter, 40)  
         } else {  
           v5300_counter.innerText = v5300_target 
           v5300_st = true
         }  
       }  
       v5300_updateCounter()  
     })
  }

  // Increment counter code for 98% waste
  if (document.getElementById("shopify-section-template--15811711402173__16351723259261e814") && ($(window).scrollTop() >= v98.offset().top - v98.outerHeight()) && v98_st == false && v98_chk == false) {
     v98_chk = true
     const v98_counters = document.querySelectorAll('#Banner-template--15811711402173__16351723259261e814 .banner__heading') 
     v98_counters.forEach(v98_counter => {  
       v98_counter.innerText = '1'  
       const v98_updateCounter = () => {  
         const v98_target = +98  
         const v98_c = +v98_counter.innerText  
         const v98_increment = 1  
         if(v98_c < v98_target) {  
           v98_counter.innerText = `${Math.ceil(v98_c + v98_increment)}` 
           setTimeout(v98_updateCounter, 15)  
         } else {  
           v98_counter.innerText = v98_target 
           v98_st = true
         }  
       }  
       v98_updateCounter()  
     })
  }

  
});


  var bvid = document.getElementById("balVideoId");
  if(bvid){
  bvid.onloadeddata = function() {
     
      $(".loading-spinner").hide();
      var element = document.getElementById("banner__box__id");
      element.classList.add("fadeInDown");
      $(".loading-spinner").hide();
    
      $('#Group_57').addClass('logoFIn');
      setTimeout(function(){ $('#Group_54').addClass('logoFIn'); }, 500);
      setTimeout(function(){ $('#Group_60').addClass('logoFIn'); }, 1000);
      setTimeout(function(){ $('#Group_63').addClass('logoFIn'); }, 1700);
  };
  }
